export const T = {
  nav: {
    home: { en: "Home", mr: "मुख्यपृष्ठ" },
    products: { en: "Products", mr: "उत्पादने" },
    brands: { en: "Brands", mr: "ब्रँड्स" },
    about: { en: "About", mr: "आमच्याबद्दल" },
    gallery: { en: "Gallery", mr: "गॅलरी" },
    reviews: { en: "Reviews", mr: "अभिप्राय" },
    contact: { en: "Contact", mr: "संपर्क" },
  },
  hero: {
    since: { en: "Serving since", mr: "सेवेत" },
    line1: { en: "Build with", mr: "बांधा" },
    line2: { en: "materials that", mr: "अशा साहित्याने" },
    line3: { en: "last a lifetime.", mr: "जे आयुष्यभर टिकेल." },
    sub: {
      en: "Your one-stop destination near Vairag for premium tiles, granite, sanitaryware, plumbing and waterproofing.",
      mr: "वैरागजवळील उत्तम टाइल्स, ग्रॅनाइट, सॅनिटरीवेअर, प्लंबिंग व वॉटरप्रूफिंगसाठी एकमेव ठिकाण.",
    },
    cta_call: { en: "Call Now", mr: "आता कॉल करा" },
    cta_wa: { en: "WhatsApp Enquiry", mr: "व्हॉट्सअ‍ॅप चौकशी" },
    cta_ig: { en: "Follow on Instagram", mr: "इन्स्टाग्रामवर फॉलो करा" },
  },
  products: {
    kicker: { en: "What we stock", mr: "आमच्याकडे उपलब्ध" },
    title: { en: "Our Products", mr: "आमची उत्पादने" },
    enquire: { en: "Enquire", mr: "चौकशी करा" },
  },
  brands: {
    kicker: { en: "Trusted names", mr: "विश्वासू ब्रँड्स" },
    title: { en: "Brands We Carry", mr: "आमचे ब्रँड्स" },
  },
  about: {
    kicker: { en: "Why choose us", mr: "आम्हाला का निवडावे" },
    title: { en: "About Us", mr: "आमच्याबद्दल" },
    chapters: [
      {
        no: "01",
        h: { en: "Two decades of trust", mr: "दोन दशकांचा विश्वास" },
        p: {
          en: "For over 20 years families and builders around Vairag have trusted us for honest advice and genuine products, from a single tile box to an entire home.",
          mr: "गेल्या २० वर्षांहून अधिक काळ वैराग परिसरातील कुटुंबे व बांधकाम व्यावसायिक प्रामाणिक सल्ला व दर्जेदार उत्पादनांसाठी आमच्यावर विश्वास ठेवतात.",
        },
      },
      {
        no: "02",
        h: { en: "Only quality products", mr: "फक्त दर्जेदार उत्पादने" },
        p: {
          en: "We stock only from reputed brands and inspect every consignment, so what reaches your site is exactly what you paid for.",
          mr: "आम्ही फक्त नामांकित ब्रँड्सचा माल ठेवतो व प्रत्येक साठा तपासतो, त्यामुळे तुमच्या साइटवर योग्यच माल पोहोचतो.",
        },
      },
      {
        no: "03",
        h: { en: "Service that shows up", mr: "वेळेवर सेवा" },
        p: {
          en: "Fast local delivery, help choosing the right material and after-sale support. We treat your project like our own.",
          mr: "जलद स्थानिक डिलिव्हरी, योग्य साहित्य निवडण्यास मदत व विक्रीनंतरची सेवा. तुमचा प्रकल्प आम्ही आमचाच समजतो.",
        },
      },
    ],
  },
  gallery: {
    kicker: { en: "See it in person", mr: "प्रत्यक्ष पहा" },
    title: { en: "Gallery", mr: "गॅलरी" },
  },
  reviews: {
    kicker: { en: "Words from customers", mr: "ग्राहकांचे शब्द" },
    title: { en: "Customer Reviews", mr: "ग्राहक अभिप्राय" },
    write: { en: "Write a review", mr: "अभिप्राय लिहा" },
    name: { en: "Your name", mr: "तुमचे नाव" },
    rating: { en: "Rating", mr: "रेटिंग" },
    message: { en: "Your review", mr: "तुमचा अभिप्राय" },
    submit: { en: "Submit review", mr: "अभिप्राय पाठवा" },
    thanks: { en: "Thank you! Your review will appear after approval.", mr: "धन्यवाद! मंजुरीनंतर तुमचा अभिप्राय दिसेल." },
    empty: { en: "Be the first to review us.", mr: "पहिला अभिप्राय तुम्ही द्या." },
  },
  contact: {
    kicker: { en: "Visit or call", mr: "भेट द्या किंवा कॉल करा" },
    title: { en: "Contact Us", mr: "संपर्क" },
    phone: { en: "Phone", mr: "फोन" },
    whatsapp: { en: "WhatsApp", mr: "व्हॉट्सअ‍ॅप" },
    email: { en: "Email", mr: "ईमेल" },
    instagram: { en: "Instagram", mr: "इन्स्टाग्राम" },
    address: { en: "Address", mr: "पत्ता" },
    hours: { en: "Business Hours", mr: "कामाच्या वेळा" },
    directions: { en: "Get Directions", mr: "दिशा मिळवा" },
    form_title: { en: "Send an enquiry", mr: "चौकशी पाठवा" },
    yourphone: { en: "Your phone", mr: "तुमचा फोन" },
    send: { en: "Send enquiry", mr: "चौकशी पाठवा" },
    sent: { en: "Enquiry sent! We'll call you back soon.", mr: "चौकशी पाठवली! आम्ही लवकरच कॉल करू." },
  },
  footer: {
    rights: { en: "All rights reserved.", mr: "सर्व हक्क राखीव." },
    admin: { en: "Admin", mr: "अ‍ॅडमिन" },
  },
};

export const tr = (node, lang) => (node && node[lang]) || (node && node.en) || "";
